import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import './header.scss'

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const navItems = [
    { label: 'Home', path: '/' },
    // { label: 'Latest Songs', path: '/latest' },
    // { label: 'Trending', path: '/trending' },
    { label: 'Albums', path: '/albums' },
    // { label: 'Artists', path: '/artists' },
  ]

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="header__container">
        <Link to="/" className="header__logo">
          <StaticImage
            src="../../images/logo/logo.png"
            alt="Thamizh Songs Logo"
            width={40}
            height={40}
          />
          <span>Thamizh Songs</span>
        </Link>

        <nav className="header__nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="header__nav-item"
              activeClassName="header__nav-item--active"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <button
          className="header__mobile-menu"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <nav className={`header__mobile-nav ${isMobileMenuOpen ? 'header__mobile-nav--open' : ''}`}>
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className="header__mobile-nav-item"
            activeClassName="header__mobile-nav-item--active"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            {item.label}
          </Link>
        ))}
      </nav>
    </header>
  )
}

export default Header